import CryptoJS from 'crypto-js';

// Same SECRET_KEY as qrbuddy-web
const SECRET_KEY = 'jcR2bsMqNwF';

/**
 * Decrypt string using AES encryption (same as qrbuddy-web)
 * @param value - Encrypted string
 * @returns Decrypted string
 */
export const decryptString = (value: string): string => {
  let decryptedString = '';

  // Reverse the URL-safe replacements
  const dataString = value
    .replace(/p1L2u3S/g, '+')
    .replace(/s1L2a3S4h/g, '/')
    .replace(/e1Q2u3A4l/g, '=');

  try {
    decryptedString = CryptoJS.AES.decrypt(
      dataString,
      SECRET_KEY
    ).toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error('Decryption error:', error);
  }

  return decryptedString;
};

/**
 * Encrypt string using AES encryption (same as qrbuddy-web)
 * @param value - Plain string to encrypt
 * @returns Encrypted string
 */
export const encryptString = (value: string): string => {
  const ciphertext = CryptoJS.AES.encrypt(
    String(value),
    SECRET_KEY
  ).toString();

  // Make URL-safe by replacing special characters
  return ciphertext
    .replace(/\+/g, 'p1L2u3S')
    .replace(/\//g, 's1L2a3S4h')
    .replace(/=/g, 'e1Q2u3A4l');
};

/**
 * Store data in localStorage with encryption
 * @param key - Storage key
 * @param value - Value to store
 */
export const setEncryptedItem = (key: string, value: any): void => {
  try {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value);
    const encrypted = encryptString(stringValue);
    localStorage.setItem(key, encrypted);
  } catch (error) {
    console.error('Error storing encrypted item:', error);
  }
};

/**
 * Retrieve and decrypt data from localStorage
 * @param key - Storage key
 * @returns Decrypted value or null
 */
export const getEncryptedItem = (key: string): any => {
  try {
    const encrypted = localStorage.getItem(key);
    if (!encrypted) return null;

    const decrypted = decryptString(encrypted);
    if (!decrypted) return null;

    // Try to parse as JSON, otherwise return as string
    try {
      return JSON.parse(decrypted);
    } catch {
      return decrypted;
    }
  } catch (error) {
    console.error('Error retrieving encrypted item:', error);
    return null;
  }
};

/**
 * Remove item from localStorage
 * @param key - Storage key
 */
export const removeEncryptedItem = (key: string): void => {
  localStorage.removeItem(key);
};

/**
 * Clear all encrypted items (optional, clear all localStorage)
 */
export const clearEncryptedStorage = (): void => {
  localStorage.clear();
};
